import { Link } from 'react-router-dom';

export default function Footer() {
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-foreground-950 text-foreground-300">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-xl text-background-50"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">
                鲍鱼视频
              </span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-400">
              从海底到餐桌，记录鲍鱼的每一刻。国内首家专注于鲍鱼全产业链视频内容的垂直平台。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              视频分类
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/category/yangzhi"
                  onClick={handleLinkClick}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  鲍鱼养殖
                </Link>
              </li>
              <li>
                <Link
                  to="/category/bulao"
                  onClick={handleLinkClick}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  鲍鱼捕捞
                </Link>
              </li>
              <li>
                <Link
                  to="/category/jiagong"
                  onClick={handleLinkClick}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  鲍鱼加工
                </Link>
              </li>
              <li>
                <Link
                  to="/category/pengren"
                  onClick={handleLinkClick}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  鲍鱼烹饪
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              更多栏目
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/category/jianbie"
                  onClick={handleLinkClick}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  品种鉴别
                </Link>
              </li>
              <li>
                <Link
                  to="/category/yingyang"
                  onClick={handleLinkClick}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  营养科普
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  onClick={handleLinkClick}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  onClick={handleLinkClick}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  首页
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              联系方式
            </h4>
            <ul className="space-y-2 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>contact@baoyushipin.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line"></i>
                <span>baoyushipin</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2020-2026 鲍鱼视频 BaoyuShipin.com 版权所有 | 从海底到餐桌，记录鲍鱼的每一刻
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-primary-400 transition-colors"
              rel="nofollow"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-primary-400 transition-colors"
              rel="nofollow"
            >
              使用条款
            </a>
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-primary-400 transition-colors"
              rel="nofollow"
            >
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}